// 45-B, paczka PH — harmonogram: tryby, dni ciszy, naglowek wyniku, lista kont (C0, KONTRAKTY 2026-09-24).
// Poddrzewo `appCampaigns.h45.*`: ten plik edytuje TYLKO jego paczka; klucze PL i EN rownoczesnie.
// Teksty: MAPA 45-B „Teksty PL / EN”; zero zdan objasniajacych (regula 8) — dane, pigulki, male przyciski.
export const appCampaignsH45 = {
  h45: {
    // Naglowek arkusza = wynik planu, piec danych (regula 56; decyzja 1 MAPY 45-B).
    result: {
      end: 'Koniec',
      // Czytnik: „Posty 25/31”.
      ofPool: 'Posty: {placed} z {pool}',
      // Czytnik: krazek „!” przy „Koniec”, gdy koniec wynika z wlasnego harmonogramu konta.
      ownEnd: 'koniec wyznacza konto z własnym harmonogramem',
    },
    mode: {
      label: 'Tryb harmonogramu',
      range: 'Start i koniec',
      weekly: 'Tygodniowo',
    },
    start: {
      today: 'dziś, {time}',
      tomorrow: 'jutro, {time}',
      at: '{date}, {time}',
      // Czytnik: przycisk otwierajacy pola dnia i godziny startu.
      change: 'Zmień start: {when}',
      day: 'Dzień startu',
      time: 'Godzina startu',
    },
    end: {
      none: 'bez końca',
      date: 'data',
      dateLabel: 'Data końca',
      earlier: 'Wcześniej',
      later: 'Później',
      weeks_one: '{n} tydz.',
      weeks_few: '{n} tyg.',
      weeks_many: '{n} tyg.',
    },
    duration: 'Czas trwania',
    perDay: {
      label: 'Dziennie na konto',
      from: 'od',
      to: 'do',
      min: 'Dziennie na konto od',
      max: 'Dziennie na konto do',
    },
    advanced: {
      label: 'Zaawansowane',
      hours: 'Godziny',
      hoursFrom: 'Godziny od',
      hoursTo: 'Godziny do',
      gap: 'Odstęp',
      gapValue: 'co {n} h',
      quiet: 'Dni ciszy',
      work: 'Pracy',
      workMin: 'Pracy od',
      workMax: 'Pracy do',
      quietLen: 'Ciszy',
      days_one: 'dzień',
      days_few: 'dni',
      days_many: 'dni',
      quietIn: 'Cisza w planie',
      quietOff: 'bez dni ciszy',
      // Liczba rządzi rzeczownikiem: forma wg górnej granicy („co 5-7 dni”, „co 1-1 dzień”).
      quietOn_one: 'cisza co {min}-{max} dzień',
      quietOn_few: 'cisza co {min}-{max} dni',
      quietOn_many: 'cisza co {min}-{max} dni',
      quietCell: 'dzień ciszy',
    },
    week: {
      label: 'Tydzień planu',
    },
    accounts: {
      title: 'Konta',
      pace: '{min}-{max} dziennie',
      paceOne: '{n} dziennie',
      perWeek: '{n} / tydz.',
      until: 'do {date}',
      // Czytnik: „11/11” przy koncie.
      count: 'Posty konta: {placed} z {assigned}',
      lifted: 'limity zdjęte',
      own: 'własny harmonogram',
    },
    why: {
      limit: 'limit {n} dziennie',
      gap: 'odstęp {n} h',
      window: 'okno {from}-{to}',
      own: 'własny harmonogram',
    },
    fix: {
      limit: 'Zmień limit',
      gap: 'Zmień odstęp',
      window: 'Zmień okno',
      extend: 'Wydłuż do {date}',
      lift: 'Zdejmij limity',
      liftLabel: 'Zdejmij limity konta {name} w tym planie',
      restore: 'Przywróć limity',
      restoreLabel: 'Przywróć limity konta {name} w tym planie',
    },
    dryRun: {
      error: 'Nie udało się policzyć planu.',
      retry: 'Ponów',
    },
    // Pigulka kroku 4 przy odmowie ustawien harmonogramu (N2-PH): dana, nie zdanie.
    fault: {
      gap: 'odstęp za krótki',
      start: 'start za wcześnie',
      slot: 'godzina {time}',
      week: 'za dużo godzin w dniu',
      window: 'koniec przed startem',
    },
    // Wartosc wiersza kroku 4 (regula 16): skrot tego, co ustawiono.
    value: {
      range: 'od {start} · {min}-{max} dziennie · bez końca',
      rangeOne: 'od {start} · {n} dziennie · bez końca',
      rangeEnd: 'od {start} do {end}',
      weekly: 'Tygodniowo · {n} / tydz. · {duration}',
    },
    // Po 201 z planem niepelnym (D8): zdanie sukcesu jako dane.
    partial_one: 'Zaplanowano {n} · {left} został w bibliotece',
    partial_few: 'Zaplanowano {n} · {left} zostały w bibliotece',
    partial_many: 'Zaplanowano {n} · {left} zostało w bibliotece',
    // Pigulka po 409 `plan_changed`: plan przeliczony od nowa.
    changed: 'plan przeliczony',
  },
}
